import { isMobile } from "@common_lib/base/utils/src/tools"

const loadStyle = async (id: string, module: { default: string }) => {
  const style = document.createElement("style")
  style.id = id
  style.textContent = module.default

  document.head.appendChild(style)
}

const checkTailwindConfig = async () => {
  if (isMobile()) {
    await loadStyle(
      "mobile-custom-theme",
      await import("@/assets/styles/mobile.scss?inline")
    )
  } else {
    await loadStyle(
      "desktop-custom-theme",
      await import("@/assets/styles/desktop.scss?inline")
    )
  }
}

export default checkTailwindConfig
